module.exports = __webpack_public_path__ + "media/images/gallery/galaxies_off-1421da05392eda30bd65f6947ef72448.gif";